<template>
	<div>
        <v-subheader class="white--text">  Settings </v-subheader>

		<v-list subheader dark dense three-line>




			<v-list-item>

				<template v-slot:default="{ active, }">

					<v-list-item-content>
						<v-list-item-title>Theme Style</v-list-item-title>
						<v-list-item-subtitle class="mt-n10 white--text text-caption font-weight-light">Light or Dark
						</v-list-item-subtitle>
					</v-list-item-content>
					<v-switch v-model="$vuetify.theme.dark" color="accent" inset></v-switch>


				</template>
			</v-list-item>
			<v-divider></v-divider>
			<v-list-item>
				<template v-slot:default="{ active }">


					<v-list-item-content>
						<v-list-item-title>RTL</v-list-item-title>
						<v-list-item-subtitle class="mt-n10 text-caption font-weight-light">Left or Right
						</v-list-item-subtitle>

					</v-list-item-content>
					<v-switch v-model="$vuetify.rtl" color="accent" inset class="mt-0 mx-2"></v-switch>
				</template>
			</v-list-item>
		
			
			<v-divider></v-divider>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>Layout Theme</v-list-item-title>
					<v-list-item-subtitle class=" text-caption font-weight-light">Vertical,Horizontal or Mini
					</v-list-item-subtitle>
					<v-list-item-subtitle>
						  <v-btn-toggle background-color="primary" :input-value="active" v-model="text1" shaped mandatory
									  tile color="primary" class="d-flex flex-column mt-2" group>
							<v-btn  value="layout-base" class="d-flex flex-column mb-6" text
								   @click="setLayout('layout-vertical')">
								Layout Vertical
							</v-btn>
							<v-btn value="layout-horizontal" text class="d-flex flex-column mb-6"
								   @click="setLayout('layout-horizontal')">
								Layout Horizontal
							</v-btn>
							<v-btn class="d-flex flex-column mb-6" text value="layout-mini"
								   @click="setLayout('layout-mini')">
								Layout Mini
							</v-btn>
                         
						</v-btn-toggle>
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>


		</v-list>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				toggle_none: null,
				text1: 'layout-mini',
				toggle_one: 0,
				drawer: true,
				active: true,
				value: 1,
				appBarDark: false,
				appBarLight: false,
				drawerDark: false,
				drawerLight: false,
				settings: true,
				drawermini: false,
				drawerLeft: true,
				DrawerHorizontal: false,
				datePicker: new Date().toISOString().substr(0, 10),
				checkbox: true,
				swatches: [
					['#5D5DFF', '#0E3EDA', '#488FB1', '#A73489'],
					['#800080', '#56BBF1', '#7027A0', '#FF3D68'],
					['#b949ec', '#ff7373', '#C32BAD', '#800000'],

				],
				layouts: ['layout-base', 'layout-horizontal', 'layout-mini'],

				selectedLayout: "",
			}
		},

		computed: {
			currentPrimary() {
				return this.$vuetify.theme.currentTheme.primary;
			},
			currentSecondary() {
				return this.$vuetify.theme.currentTheme.primary;
			},
			currentAccent() {
				return this.$vuetify.theme.currentTheme.accent;
			}
		},

		methods: {
			changeLayout() {
				this.$store.dispatch("setLayout", this.selectedLayout.length == 0 ? this.layouts[0] : this
					.selectedLayout);
			},
			setLayout(layout) {
				this.$store.commit('SET_LAYOUT', layout)
			}

		},
	}
</script>